import { Navigate } from 'react-router';

/** Workspace plan now lives on Organization. Bookmarks still resolve. */
export function PlanSettingsPage() {
  return <Navigate to="/settings#workspace-plan" replace />;
}
